module.exports = __webpack_public_path__ + "static/img/icon_psd.aa51f117.png";